import { render, staticRenderFns } from "./BlogContent.vue?vue&type=template&id=0a81c8b0&"
import script from "./BlogContent.vue?vue&type=script&lang=js&"
export * from "./BlogContent.vue?vue&type=script&lang=js&"
import style0 from "./BlogContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports